
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/univers/[universeId]",
      function () {
        return require("private-next-pages/univers/[universeId]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/univers/[universeId]"])
      });
    }
  